export default __webpack_public_path__ + "static/blob-04-d0acc477894ca0311ae76a896f49583b.svg";